import React, { Component } from "react";
import {
  NavBar,
  Icon,
  List,
  Checkbox,
  Button,
  Pagination,
  WingBlank,
  WhiteSpace,
  Toast,
  Badge,
  Radio,
} from "antd-mobile";
import { createForm } from "rc-form";
import NoneDatas from "../../../components/noneDatas";
import axios from "../../../service/axios";

const Item = List.Item;
const CheckboxItem = Checkbox.CheckboxItem;
const RadioItem = Radio.RadioItem;

const selectedContainer = {
  position: "fixed",
  width: "100%",
  top: "45px",
  background: "#f5f5f5",
  height: "100%",
  zIndex: "11",
  transition: "left 0.4s",
  overflowY: "scroll",
};

export class TransferUsers extends Component {
  state = {
    usersDrawer: document.body.clientWidth,
    pageTotalNum: 0,
    pageNo: 1,
    drawerLeft: document.body.clientWidth,
    drawerType: 0,
    fromGroupList: [],
    targetGroupList: [],
    targetAdminList: [],
    pageTotalNum2: 0,
    pageNo2: 1,
    fromGroup: {},
    targetGroup: {},
    targetAdmin: {},
    fromGroupmemberList: [],
    selectUserList: [],
  };
  async componentDidMount() {
    Toast.loading("加载中...", 0);
    this.getFromGroupList(1);
  }


  getFromGroupList(e) {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/group/list/adminId", {
          page: {
            pageSize: 10,
            pageNo: e,
          },
          adminId: this.props.match.params.id,
        })
        .then(res => {
          resolve();
          if (res && res.status == 200 && res.data && res.data.resultList) {
            this.setState({
              fromGroupList: res.data.resultList,
              pageNo2: res.data.pageNo,
              pageTotalNum2: Math.ceil(res.data.totalCount / 10),
            });
          }
        });
    });
  }

  onSelectDrawerLeft = (type) => {
    this.setState({
      drawerLeft: 0,
      drawerType: type,
    });
    if (type == 0) {
      this.getFromGroupList(1);
    } else if (type == 1) {
      this.getTargetGroupList(1);
    } else {
      this.getTargetAdminList(1);
    }
  };

  onFromGroupPageChange(e) {
    this.setState({
      pageNo2: e,
    });
    this.getFromGroupList(e);
  }

  onTargetAdminPageChange(e) {
    this.setState({
      pageNo2: e,
    });
    this.getTargetAdminList(e);
  }

  onTargetGroupPageChange(e) {
    this.setState({
      pageNo2: e,
    });
    this.getTargetGroupList(e);
  }

  onFromGroupChange = (e) => {
    console.log('checkbox', e);
    this.props.form.setFieldsValue({
      selectGid: e.gid,
      uids: [],
    });
    this.setState({
      fromGroup: e,
      selectUserList: [],
    }, () => {
      // this.setState执行完的回调
      this.getFromGroupmemberList(1);
    });

  };

  onTargetGroupChange = (e) => {
    console.log('checkbox', e);
    this.props.form.setFieldsValue({
      gid: e.gid,
    });
    this.setState({
      targetGroup: e,
    });
  };

  onTargetAdminChange = (e) => {
    console.log('checkbox', e);
    this.props.form.setFieldsValue({
      targetId: e.id,
      gid: null,
    });
    this.setState({
      targetAdmin: e,
      targetGroup: {},
    }, () => {
      // this.setState执行完的回调
      this.getTargetGroupList(1);
    });
  };

  getFromGroupmemberList(pageNo) {
    return new Promise((resolve, reject) => {
      const { fromGroup } = this.state;
      axios.get("/api/group/members", {
        params: {
          pageSize: 10,
          pageNo,
          gid: fromGroup && Object.values(fromGroup).length > 0 ? fromGroup.gid : null,
        },
      }).then(res => {
        resolve();
        if (res && res.status == 200 && res.data && res.data.resultList) {
          this.setState({
            fromGroupmemberList: res.data.resultList,
            pageNo: res.data.pageNo,
            pageTotalNum: Math.ceil(res.data.totalCount / 10),
          });
        }
      });
    });
  }

  onMembersChange(e, item) {
    const { selectUserList } = this.state;
    let arr = [...selectUserList];
    if (e.target.checked) {
      arr.push(item);
      this.setState({
        selectUserList: arr,
      });
      selectUserList.push(item);
      this.props.form.setFieldsValue({
        uids: arr.map(item => item.uid),
      });
    } else {
      arr.splice(arr.map(item => item.uid).indexOf(item.uid), 1);
      this.props.form.setFieldsValue({
        uids: arr.map(item => item.uid),
      });
      this.setState({
        selectUserList: arr,
      });
    }
  }


  deleteSelectUserList(item) {
    const { selectUserList } = this.state;
    let arr = [...selectUserList];
    arr.splice(arr.map(item => item.uid).indexOf(item.uid), 1);
    this.setState({
      selectUserList: arr,
    });
  }

  getTargetGroupList(e) {
    return new Promise((resolve, reject) => {
      const { targetAdmin } = this.state;
      axios
        .post("/api/group/list/adminId", {
          page: {
            pageSize: 10,
            pageNo: e,
          },
          adminId: targetAdmin && Object.values(targetAdmin).length > 0 ? targetAdmin.id : null,
        })
        .then(res => {
          resolve();
          if (res && res.status == 200 && res.data && res.data.resultList) {
            this.setState({
              targetGroupList: res.data.resultList,
              pageNo2: res.data.pageNo,
              pageTotalNum2: Math.ceil(res.data.totalCount / 10),
            });
          }
        });
    });
  }

  getTargetAdminList(e) {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/user/admin/list/lowest_level", {
          page: {
            pageSize: 10,
            pageNo: e,
          },
        })
        .then(res => {
          resolve();
          if (res && res.status == 200 && res.data && res.data.resultList) {
            this.setState({
              targetAdminList: res.data.resultList,
              pageNo2: res.data.pageNo,
              pageTotalNum2: Math.ceil(res.data.totalCount / 10),
            });
          }
        });
    });
  }

  onSelectedAll = e => {
    console.log(e);
    const { selectUserList, fromGroupmemberList } = this.state;
    let arrStr = [...fromGroupmemberList];
    let arr = [...selectUserList];
    let arrUid = [...selectUserList].map(item => item.uid);
    if (e.target.checked) {
      arrStr.map(item => {
        if (!arrUid.includes(item.uid)) {
          arr.push(item);
        }
      });
    } else {
      arrStr.map(items => {
        if (arrUid.includes(items.uid)) {
          arr.splice(arr.map(item => item.uid).indexOf(items.uid), 1);
        }
      });
    }
    this.props.form.setFieldsValue({
      uids: arr.map(item => item.uid),
    });
    this.setState({
      selectUserList: arr,
    });
  };

  onSave = () => {
    this.props.form.validateFields({ force: true }, error => {
      console.log(error);
      if (!error) {
        const fildsValue = this.props.form.getFieldsValue();
        console.log('fildsValue ==== ', fildsValue)
        Toast.loading("加载中...", 10);
        axios.post("/api/user/admin/transfer/user", {
          ...fildsValue,
        }).then(res => {
          console.log(res);
          if (res) {
            if (res.status == 200) {
              Toast.success(res.message, 2, () => {
                window.history.go(-1);
              });
            }
            else {
              Toast.fail(res.message);
            }
          }
        });
      }
    });
  };


  render() {
    const {
      usersDrawer,
      pageTotalNum,
      pageNo,
      drawerLeft,
      fromGroupList,
      pageTotalNum2,
      pageNo2,
      fromGroup,
      fromGroupmemberList,
      selectUserList,
      drawerType,
      targetGroupList,
      targetAdminList,
      targetGroup,
      targetAdmin,
    } = this.state;

    const {
      getFieldProps,
      getFieldError,
      setFieldsValue,
    } = this.props.form;

    return (
      <div className="user-list">
        <div className="header-sticky">
          <NavBar
            icon={<Icon type="left" />}
            onLeftClick={() => this.props.history.goBack()}
          >
            用户迁移
          </NavBar>
        </div>
        <div className="sub-container">
          <List
            renderFooter={() =>
              getFieldError("fromId") ||
              getFieldError("selectGid") ||
              getFieldError("uids") ||
              getFieldError("targetId") ||
              getFieldError("gid")
            }>
            <Item
              {...getFieldProps("fromId", {
                rules: [{
                  required: true,
                  message: "请选择迁移管理员",
                }],
                initialValue: this.props.match.params.id,
              })}
              extra={this.props.match.params.loginName}><i className="red-star">*</i>迁移管理员</Item>
            <Item
              {...getFieldProps("selectGid", {
                rules: [{
                  required: true,
                  message: "请选择群组",
                }],
              })}
              arrow="horizontal"
              extra={`${fromGroup && Object.values(fromGroup).length > 0 ? fromGroup.name : '无'}`}
              onClick={() => this.onSelectDrawerLeft(0)}
            >
              <i className="red-star">*</i>迁移群组
            </Item>
            <Item
              {...getFieldProps("uids", {
                rules: [{
                  required: true,
                  message: "请选择迁移用户",
                }],
              })}
              arrow="horizontal"
              extra={`${selectUserList.length}用户`}
              onClick={() => this.setState({
                usersDrawer: 0,
              })}
            >
              <i className="red-star">*</i>群组成员
            </Item>
            <Item
              {...getFieldProps("targetId", {
                rules: [{
                  required: true,
                  message: "请选择目标管理员",
                }],
              })}
              arrow="horizontal"
              extra={`${targetAdmin && Object.values(targetAdmin).length > 0 ? targetAdmin.name : '无'}`}
              onClick={() => this.onSelectDrawerLeft(2)}
            >
              <i className="red-star">*</i>目标管理员
            </Item>
            <Item
              {...getFieldProps("gid", {
                rules: [{
                  required: true,
                  message: "请选择目标群组",
                }],
              })}
              arrow="horizontal"
              extra={`${targetGroup && Object.values(targetGroup).length > 0 ? targetGroup.name : '无'}`}
              onClick={() => this.onSelectDrawerLeft(1)}
            >
              <i className="red-star">*</i>目标群组
            </Item>
            <Item>
              <WingBlank>
                <Button type="primary" onClick={this.onSave}>
                  保存
                </Button>
                <WhiteSpace size="lg" />
                <Button onClick={() => this.props.history.goBack()}>
                  返回
                </Button>
              </WingBlank>
            </Item>
          </List>
        </div>

        <div style={{ ...selectedContainer, left: drawerLeft }}>
          <List renderHeader={drawerType == 2 ? "管理员" : "群组列表"}>
            {drawerType == 0 ? (
              fromGroupList.length == 0 ? <NoneDatas /> : fromGroupList.map((item, index) => (
                <RadioItem key={index} checked={fromGroup && fromGroup.gid == item.gid} onChange={() => this.onFromGroupChange(item)}>
                  {item.name}
                </RadioItem>
              ))) : drawerType == 1 ? (
                targetGroupList.length == 0 ? <NoneDatas /> : targetGroupList.map((item, index) => (
                  <RadioItem key={index} checked={targetGroup && targetGroup.gid == item.gid} onChange={() => this.onTargetGroupChange(item)}>
                    {item.name}
                  </RadioItem>
                ))) : (
                  targetAdminList.length == 0 ? <NoneDatas /> : targetAdminList.map((item, index) => (
                    <RadioItem key={index} checked={targetAdmin && targetAdmin.id == item.id} onChange={() => this.onTargetAdminChange(item)}>
                      {item.name}
                    </RadioItem>
                  )))}
            <WhiteSpace size="lg" />
            <WingBlank>
              {pageTotalNum2 > 0 ? (
                <Pagination
                  total={pageTotalNum2}
                  current={pageNo2}
                  locale={{
                    prevText: "上一页",
                    nextText: "下一页",
                  }}
                  onChange={e => drawerType == 0 ? this.onFromGroupPageChange(e) : drawerType == 1 ? this.onTargetGroupPageChange(e) : this.onTargetAdminPageChange(e)}
                />
              ) : (
                  ""
                )}
            </WingBlank>

            <Item>
              <Button
                type="primary"
                onClick={() =>
                  this.setState({
                    drawerLeft: document.body.clientWidth,
                  })
                }
              >
                确定
              </Button>
              <WhiteSpace size="lg" />
              <Button
                onClick={() =>
                  this.setState({
                    drawerLeft: document.body.clientWidth,
                  })
                }
              >
                返回
              </Button>
            </Item>
            <WhiteSpace size="lg" />
            <WhiteSpace size="lg" />
          </List>
        </div>

        <div style={{ ...selectedContainer, left: usersDrawer }}>
          <List renderHeader="已选用户">
            <div style={{ height: 200, overflowY: "scroll" }}>
              {selectUserList.map((item, index) => (
                <Item
                  key={index}
                  extra={
                    <Icon
                      style={{ color: "red", padding: "2px 5px" }}
                      onClick={() => this.deleteSelectUserList(item)}
                      type="cross"
                    />
                  }
                >
                  &ensp; &ensp;
                  {item.name}
                </Item>
              ))}
            </div>
          </List>
          <List renderHeader="群组成员">
            {fromGroupmemberList.map((item, index) => (
              <CheckboxItem
                checked={selectUserList.map(item => item.uid).includes(item.uid)}
                key={index}
                onChange={e => this.onMembersChange(e, item)}
              >
                {item.name}
              </CheckboxItem>
            ))}
            <CheckboxItem onChange={e => this.onSelectedAll(e)}>
              <Badge text="全选"
                style={{
                  backgroundColor: '#fff',
                  borderRadius: 2,
                  color: '#108ee9',
                  border: '1px solid #108ee9',
                }}
              />
            </CheckboxItem>
            <WhiteSpace size="lg" />
            <WingBlank>
              {pageTotalNum > 0 ? (
                <Pagination
                  total={pageTotalNum}
                  current={pageNo}
                  locale={{
                    prevText: "上一页",
                    nextText: "下一页",
                  }}
                  onChange={e => this.getFromGroupmemberList(e)}
                />
              ) : (
                  ""
                )}
            </WingBlank>

            <Item>
              <Button
                type="primary"
                onClick={() =>
                  this.setState({
                    usersDrawer: document.body.clientWidth,
                  })
                }
              >
                确定
              </Button>
              <WhiteSpace size="lg" />
              <Button
                onClick={() =>
                  this.setState({
                    usersDrawer: document.body.clientWidth,
                  })
                }
              >
                返回
              </Button>
            </Item>
            <WhiteSpace size="lg" />
            <WhiteSpace size="lg" />
          </List>
        </div>
      </div>
    );
  }
}

export default createForm()(TransferUsers);
